import { Box, Button, Heading, Text, VStack } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import type { ExportFormatType } from "../../../../common/model/exportFormatType";
import { useUser } from "../../contexts/userContext";
import type User from "../../domain/User";
import {
  actionButton,
  cardHeading,
  glassCard,
  pageContainer,
  sectionHeading,
} from "../../themes/design";

interface UserProfileProps {
  user: User;
}

const UserProfile: React.FC<UserProfileProps> = ({ user }) => {
  const { t } = useTranslation();

  return (
    <Box {...glassCard} minW="400px">
      <Heading {...cardHeading}>{t("UserProfile")}</Heading>
      <VStack spacing={2} align="stretch">
        <Text color="primary.200">
          <strong>{t("Name")}:</strong> {user.name}
        </Text>
        <Text color="primary.200">
          <strong>{t("Email")}:</strong> {user.email}
        </Text>
        <Text color="primary.200">
          <strong>{t("UserName")}:</strong> {user.userName}
        </Text>
      </VStack>
    </Box>
  );
};

interface ExportProps {
  exportUserDataAsync: (format: ExportFormatType) => Promise<void>;
}

const Export: React.FC<ExportProps> = (props) => {
  const { t } = useTranslation();

  const exportUserData = async (format: ExportFormatType): Promise<void> => {
    await props.exportUserDataAsync(format);
  };

  return (
    <Box {...glassCard} textAlign="center" minW="400px">
      <Heading {...cardHeading}>{t("Actions")}</Heading>
      <VStack spacing={3} w="100%">
        <Button {...actionButton} onClick={() => exportUserData("csv")} w="100%">
          {t("Export user data as CSV")}
        </Button>
        <Button {...actionButton} onClick={() => exportUserData("json")} w="100%">
          {t("Export user data as JSON")}
        </Button>
      </VStack>
    </Box>
  );
};

const ProfilePage: React.FC = () => {
  const { t } = useTranslation();
  const { user, exportUserDataAsync } = useUser();

  if (!user) return null;

  return (
    <Box {...pageContainer}>
      <Heading {...sectionHeading}>{t("ProfilePage")}</Heading>
      <UserProfile user={user} />
      <Export exportUserDataAsync={exportUserDataAsync} />
    </Box>
  );
};

export default ProfilePage;
